export class FleetCardType {
  public static readonly ALL = 'all';
  public static readonly CORPORATE = 'corporate';
  public static readonly PERSONAL = 'personal';
}

export class FleetCardStatus {
  public static readonly ALL = 'all';
  public static readonly ACTIVE = 'active';
  public static readonly INACTIVE = 'inactive';
  public static readonly EXPIRED = 'expired';
}

export class FleetCardSoryBy {
  public static readonly FLEET_CARD_ID = 'fleet-card-id ';
  public static readonly EXPIRATION_DATE = 'expiration-date';
}

export class FleetCardInformationResponse {
  fleetCardId: string;
  fleetCardType: string;
  companyId?: number;
  companyNameTh?: string;
  companyNameEn?: string;
  status: string;
  expirationDate?: string;
  usedAmount: number;
  balanceAmount: number;
}

export class FleetCardInformationDisplay {
  fleetCardId: string;
  fleetCardType: string;
  companyId?: number;
  companyNameTh?: string;
  companyNameEn?: string;
  status: string;
  expirationDate?: string;
  usedAmount: number;
  balanceAmount: number;
  expirationDateFormatTh?: string;
  expirationDateFormatEn?: string;
}

export class RegisterFleetCardResponse {
  fleetCardId: string;
  amount: number;
  fleetCardType: string;
  companyNameTh?: string;
  companyNameEn?: string;
  expirationDate?: string;
}

export class RegisterFleetCardRequest {
  fleetCardId: string;
  secretCode: string;
  reCaptcha: string;
}

export class TransferFleetCardRequest {
  from: string;
  to: string;
  amount: number;
}

export class FleetCardOption {
  fleetCardId: string;
  fleetCardType: string;
  companyNameTh?: string;
  companyNameEn?: string;
  balanceAmount: number;
}



// WEBPACK FOOTER //
// ./src/app/model/fleet/fleet.model.ts